import API from 'services/api';
import AppsService from 'services/apps';
import SourcesService from 'services/sources';

const api = new API();
const appsService = new AppsService();
const sourcesService = new SourcesService();

const unwrapLegacyResponse = response => {
    if (response.status !== 0) {
        return Promise.reject(response.value);
    }
    return response.value;
};

export const getApps = () => appsService.getAttributionApps(false, true, false, true, true);

export const getConfiguration = () => sourcesService.getAttributionConfiguration();

export const getDefaultExportLogApi = () =>
    api
        .getJson('/logs/get_default_export_log_api', {
            method: 'GET',
            credentials: 'include',
            cache: false,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const getLogTypes = () =>
    api
        .getJson('/logs/types', {
            method: 'GET',
            credentials: 'include',
            cache: true,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const getLogFields = () =>
    api
        .getJson('/logs/fields', {
            method: 'GET',
            credentials: 'include',
            cache: false,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const getPartners = () =>
    api
        .getJson('/logs/get_partners', {
            method: 'GET',
            credentials: 'include',
            cache: false,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const getEvents = () =>
    api
        .getJson('/logs/get_events', {
            method: 'GET',
            credentials: 'include',
            cache: false,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const getCountries = () =>
    api
        .getJson('/logs/get_countries', {
            method: 'GET',
            credentials: 'include',
            cache: false,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const getDeviceIdTypes = () =>
    api
        .getJson('/logs/get_device_id_type', {
            method: 'GET',
            credentials: 'include',
            cache: false,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const getPostbackTypes = () =>
    api
        .getJson('/logs/get_postback_types', {
            method: 'GET',
            credentials: 'include',
            cache: false,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const getAgencies = () =>
    api
        .getJson('/api/agencies/self', {
            method: 'GET',
            credentials: 'include',
            cache: false,
            unique: false,
        })
        .then(unwrapLegacyResponse);

export const runLogExport = params =>
    api.getJson('/logs/export', {
        method: 'POST',
        credentials: 'include',
        body: params,
        cache: false,
        unique: true,
        channel: 'export-logs-run',
        legacyStatus: false,
    });

export const runAssistCrossoverExport = params =>
    api.getJson('/logs/assist_crossover_export', {
        method: 'POST',
        credentials: 'include',
        body: params,
        cache: false,
        unique: true,
        channel: 'assist-crossover-run',
        legacyStatus: false,
    });

export const getSqlQuery = params =>
    api.getJson('/logs/export', {
        method: 'POST',
        credentials: 'include',
        body: { ...params, returnQuery: true },
        cache: false,
        unique: true,
        channel: 'export-logs-sql',
        legacyStatus: false,
    });
